import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Review } from '../../types/types';
import dataService from '../../data/dataService';
import '../../styles/Admin.css';

const ReviewModeration: React.FC = () => {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [loading, setLoading] = useState(true);

  const loadReviews = () => {
    setLoading(true);
    fetch('/api/reviews').then(r => r.json()).then(setReviews).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { loadReviews(); }, []);

  const handleDelete = async (id: number) => {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    // Use the dataService token provider pattern for auth
    try {
      const tokenProvider = (dataService as any).tokenProvider;
      if (tokenProvider) {
        const token = await tokenProvider();
        if (token) headers['Authorization'] = `Bearer ${token}`;
      }
    } catch { /* best effort */ }

    await fetch(`/api/reviews/${id}`, { method: 'DELETE', headers });
    loadReviews();
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Review Moderation</h1>
        <nav className="admin-nav">
          <Link to="/admin">Dashboard</Link>
          <Link to="/admin/orders">Orders</Link>
          <Link to="/admin/products">Products</Link>
          <Link to="/admin/discounts">Discounts</Link>
          <Link to="/admin/agent-dashboard">Agent Demo</Link>
        </nav>
      </div>

      {loading ? <p>Loading...</p> : reviews.length === 0 ? <p>No reviews found.</p> : (
        <table className="admin-table">
          <thead>
            <tr><th>ID</th><th>Product</th><th>Reviewer</th><th>Rating</th><th>Comment</th><th>Date</th><th>Action</th></tr>
          </thead>
          <tbody>
            {reviews.map(r => (
              <tr key={r.id}>
                <td>{r.id}</td>
                <td><Link to={`/product/${r.productId}`}>#{r.productId}</Link></td>
                <td>{r.reviewer}</td>
                <td>{'⭐'.repeat(r.rating)}</td>
                <td style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.comment}</td>
                <td>{new Date(r.createdAt).toLocaleDateString()}</td>
                <td><button className="btn-danger" onClick={() => handleDelete(r.id)}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ReviewModeration;
